import { layoutStyles } from "@/themes/layoutStyles";

export const styles = {
  dialogContent: {
    ...layoutStyles.scroll,
  },

  list: {
    p: 0,
    // width: "100%",
    // maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  },

  title: {
    color: "primary.main",
  },
  icon: { width: "20px", height: "20px" },

  infoIcon: { width: "16px", height: "16px" },
};
